import React, { useEffect, useState } from "react";
import "./ModalAgregarPlan.css";
import { authFetch } from "../utils/authFetch";
import { Boton, Iconos } from "../componentes/base";

/**
 * Alta de un plan.
 *
 * Un plan no es solo un precio: guarda la VLAN, el gemport y los índices
 * de perfil con los que se autoriza una ONU. Esos números tienen que
 * existir en la OLT del nodo, y por eso el plan pertenece a una OLT.
 */
export default function ModalAgregarPlan({ onClose, onGuardar }) {
  const [olts, setOlts] = useState([]);
  const [form, setForm] = useState({
    olt_id: "",
    nombre: "",
    velocidad: "",
    costo: "",
    vlan: "",
    gemport: "",
    line_profile: "",
    srv_profile: "",
    traffic_up: "",
    traffic_down: "",
  });
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const res = await authFetch("/api/olt-config/");
        const data = await res.json();
        const lista = Array.isArray(data.olts) ? data.olts : [];
        setOlts(lista);
        if (lista.length === 1) {
          setForm((f) => ({ ...f, olt_id: String(lista[0].id) }));
        }
      } catch {
        setError("No se pudo leer la lista de OLTs.");
      }
    })();
  }, []);

  function actualizar(campo, valor) {
    setForm((f) => ({ ...f, [campo]: valor }));
    setError("");
  }

  function guardar() {
    // Los índices de perfil son parte del contrato con la OLT: un plan
    // sin ellos autoriza ONUs con comandos incompletos.
    const obligatorios = [
      ["olt_id", "la OLT"],
      ["nombre", "el nombre"],
      ["velocidad", "la velocidad"],
      ["costo", "el costo"],
      ["vlan", "la VLAN"],
      ["gemport", "el gemport"],
      ["line_profile", "el line profile"],
      ["srv_profile", "el service profile"],
      ["traffic_up", "el índice de subida"],
      ["traffic_down", "el índice de bajada"],
    ];
    const falta = obligatorios.find(([campo]) => !String(form[campo]).trim());
    if (falta) {
      setError(`Falta ${falta[1]}.`);
      return;
    }

    onGuardar({ ...form, olt_id: Number(form.olt_id) });
  }

  return (
    <div className="modal-backdrop-plan">
      <div className="modal-plan">
        <h2>Agregar plan</h2>

        <div className="form-grid-plan">
          <select
            value={form.olt_id}
            onChange={(e) => actualizar("olt_id", e.target.value)}
          >
            <option value="">OLT del plan…</option>
            {olts.map((o) => (
              <option key={o.id} value={o.id}>
                {o.nombre || o.host}
              </option>
            ))}
          </select>

          <input
            placeholder="Nombre del plan (Ej: 50 Megas)"
            value={form.nombre}
            onChange={(e) => actualizar("nombre", e.target.value)}
          />

          <input
            placeholder="Velocidad en Mbps"
            type="number"
            value={form.velocidad}
            onChange={(e) => actualizar("velocidad", e.target.value)}
          />

          <input
            placeholder="Costo"
            type="number"
            value={form.costo}
            onChange={(e) => actualizar("costo", e.target.value)}
          />

          <input
            placeholder="VLAN"
            type="number"
            value={form.vlan}
            onChange={(e) => actualizar("vlan", e.target.value)}
          />

          <input
            placeholder="Gemport"
            type="number"
            value={form.gemport}
            onChange={(e) => actualizar("gemport", e.target.value)}
          />

          <input
            placeholder="Line profile (índice en la OLT)"
            type="number"
            value={form.line_profile}
            onChange={(e) => actualizar("line_profile", e.target.value)}
          />

          <input
            placeholder="Service profile (índice en la OLT)"
            type="number"
            value={form.srv_profile}
            onChange={(e) => actualizar("srv_profile", e.target.value)}
          />

          {/* Estos dos campos se llenaban solos con velocidad × 1024, es
              decir kbps. Pero van a parar a `inbound traffic-table index`,
              que espera el ÍNDICE de la tabla, no su ancho de banda: un
              plan de 50 Mbps generaba `index 51200` y el comando no era
              válido. Ahora se piden como lo que son. */}
          <input
            placeholder="Traffic table de subida (índice)"
            type="number"
            value={form.traffic_up}
            onChange={(e) => actualizar("traffic_up", e.target.value)}
          />

          <input
            placeholder="Traffic table de bajada (índice)"
            type="number"
            value={form.traffic_down}
            onChange={(e) => actualizar("traffic_down", e.target.value)}
          />
        </div>

        <p className="modal-plan-ayuda">
          Los índices de perfil y de traffic table son los que existen en la
          OLT. El asistente de configuración del nodo te dice cuáles faltan.
        </p>

        {error && <p className="modal-plan-error">{error}</p>}

        <div className="modal-buttons-plan">
          <Boton variante="secundario" icono={Iconos.cerrar} onClick={onClose}>
            Cancelar
          </Boton>
          <Boton icono={Iconos.confirmar} onClick={guardar}>
            Guardar plan
          </Boton>
        </div>
      </div>
    </div>
  );
}
